module.exports = __webpack_public_path__ + "img/prod_qr_tg.f87ca61c.png";